import { Config } from "../synlab-access-ui-components/model/config.model";

// these are the existing locales deployed to staging and prod
// all future locales should now follow the 4 letter country code
// all existing locales should use the existing translations
const EXISTING_LOCALES: Record<string, string> = {
  'et-EE': 'et',
  'ru-RU': 'ru',
  'en-GB': 'en',
  'hu-HU': 'hu',
  'cz-CZ': 'cz',
  'fi-FI': 'fi',
  'sv-FI': 'sv',
  'es-MX': 'es',

  // inconsitent format across ptweb, booking, account
  'it-it': 'it',
  'it-IT': 'it',
  'it': 'it',
};

export function formatLocale(locale: string, config?: Config, allowNull?: boolean): string | null {
  if (!locale) {
    if (allowNull) return null;
    return config?.DefaultLanguage ?? "en";
  }

  const trimmedLocale = locale.trim();

  if (EXISTING_LOCALES[trimmedLocale]) {
    return EXISTING_LOCALES[trimmedLocale];
  }

  // check format if xx-yy
  const validLocale = trimmedLocale.match(/^[a-z]{2}(-[a-z]{2})$/i);
  if (validLocale) {
    const [lang, region] = trimmedLocale.split(/[-_]/);
    return `${lang.toLowerCase()}-${region.toUpperCase()}`;
  }

  // check if 2-letter language code OR an incomplete xx- format
  if (/^[a-z]{2}(-[a-z]{0,2})?$/i.test(trimmedLocale)) {
    const [lang] = trimmedLocale.split(/[-_]/); 
    return lang.toLowerCase();
  }

  return "en";
}
